import { render, staticRenderFns } from "./ConvenientSearchRecord.vue?vue&type=template&id=84bd7e3c&scoped=true"
import script from "./ConvenientSearchRecord.vue?vue&type=script&lang=js"
export * from "./ConvenientSearchRecord.vue?vue&type=script&lang=js"
import style0 from "./ConvenientSearchRecord.vue?vue&type=style&index=0&id=84bd7e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bd7e3c",
  null
  
)

export default component.exports